<template>
  <div class="info-card">
    <div class="info-title">{{ title }}</div>
    <div class="info-value">{{ value }}</div>
  </div>
</template>

<script>
export default {
  name: "InfoCard",
  props: {
    title: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.info-card {
  width: 100%;
  height: 88px;
  background: rgba(242, 204, 0, 0.15);
  padding: 9px 7px;
}
.info-title {
  color: #feffff;
  font-family: "Source Han Sans CN";
  font-size: 14px;
  white-space: nowrap;
}
.info-value {
  color: var(--primary-color);
  text-align: center;
  font-family: "Source Han Sans CN";
  font-size: 20px;
  font-weight: 700;
  padding-top: 9px;
}
</style>
